import { useTranslation } from "react-i18next";
import InfoFlyUpModal from "../../../InfoFlyUpModal/index";
import InfoModal from "../../../InfoFlyUpModal/components/InfoModal";

export interface BreathingRateModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export default function BreathingRateModal({
  isOpen,
  onClose,
}: BreathingRateModalProps = {}) {
  const { t } = useTranslation();

  const modalProps = {
    title: t("HealthChart.breathingRateModal.title"),
    description: t("HealthChart.breathingRateModal.description"),
    importanceTitle: t("HealthChart.breathingRateModal.importance.title"),
    textList: t("HealthChart.breathingRateModal.disclaimer", {
      returnObjects: true,
    }),
  };

  if (isOpen !== undefined && onClose !== undefined) {
    return (
      <InfoModal
        isOpen={isOpen}
        handleClose={onClose}
        title={modalProps.title}
        description={modalProps.description}
        importanceTitle={modalProps.importanceTitle}
        textList={modalProps.textList}
      />
    );
  }

  return (
    <InfoFlyUpModal
      cardProps={{
        title: t("HealthChart.breathingRateModal.card.title"),
        description: t("HealthChart.breathingRateModal.card.description"),
      }}
      modalProps={modalProps}
    />
  );
}
